var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 48C4.35 48 2.938 47.413 1.764 46.239C0.587999 45.063 0 43.65 0 42V33H6V42H42V33H48V42C48 43.65 47.413 45.063 46.239 46.239C45.063 47.413 43.65 48 42 48H6ZM21 36V11.55L13.2 19.35L9 15L24 0L39 15L34.8 19.35L27 11.55V36H21Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1c2e55ea7b05eda4f26f98ccb63ce6cf.svg";
export { ForwardRef as ReactComponent };